export default __webpack_public_path__ + "static/media/me.598257a1.jpg";